module.exports = __webpack_public_path__ + "img/88.42a6607a.jpg";